import moment from "moment";
import { DATETIME_NOT_SECONDS_FORMAT } from "@/common/constant";
import {UserDTO, USER_TYPE} from "@/model/user";
import trans18next from "@/i18n";
import Property from "@/model/property";

export interface IMessageFile {
  name: string,
  size: number,
  type: string
}

export class MessageFileDTO implements IMessageFile {
  name: string;
  size: number;
  type: string;
}

export interface IMessage {
  _id: string;
  sender_id: string;
  sender: UserDTO;
  content: string;
  timestamp: string;
  username: string;
  avatar?: string;
  date?: string;
  system?: boolean;
  saved: boolean;
  distributed: boolean;
  seen: boolean;
  disable_actions?: boolean;
  disable_reactions?: boolean;
  room_id?: string;
  __v?: number;
  file?: IMessageFile;
  new?: boolean;
  property: Property;
}

export class MessageDTO implements IMessage {
  _id: string;
  sender_id: string;
  sender: UserDTO;
  content: string;
  timestamp: string;
  username: string;
  avatar?: string;
  date?: string;
  system?: boolean;
  saved: boolean;
  distributed: boolean;
  seen: boolean;
  disable_actions?: boolean;
  disable_reactions?: boolean;
  room_id?: string;
  __v?: number;
  file?: MessageFileDTO;
  new?: boolean;
  property: Property;
}

export default class Message extends MessageDTO {

  constructor(dto?: MessageDTO) {
    super();
    if (dto) {
      Object.assign(this, dto);
    } else {
      this.createNew();
    }
  }

  get senderIsStaff() {
    return this.sender.type == USER_TYPE.STAFF;
  }

  get propertyName() {
    if (!this.property) {
      return trans18next.t('data_was_transfered').toString();
    }
    return this.property.name
  }

  get propertyRoomNumber() {
    if (!this.property) {
      return trans18next.t('data_was_transfered').toString();
    }
    return this.property.room_number
  }

  public createNew()
  {
    Object.assign(this, {
      _id: "",
      sender_id: "",
      content: "",
      timestamp: "",
      username: "",
      avatar: "",
      date: "",
      system: false,
      saved: false,
      distributed: false,
      seen: false,
      disable_actions: false,
      disable_reactions: false,
      room_id: "",
      __v: 0
    })
  }

  public formatDate(date) {
    return moment(date).format(DATETIME_NOT_SECONDS_FORMAT)
  }
}